"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.About = void 0;
const react_1 = __importDefault(require("react"));
require("./About.scss");
const consts_1 = require("../../common/consts");
const About = () => {
    return (react_1.default.createElement("section", { className: "about-section", id: consts_1.SECTION_IDS.about },
        react_1.default.createElement("h2", null, "About Us"),
        react_1.default.createElement("p", null, "We host meetups all over the Twin Cities, and are committed to growing a community that is inclusive to all that share the love of board, card and tabletop games within the Twin Cities. All are welcome, no matter your background. This includes but is not limited to, your engagement, your experience, or the level of competitiveness with which you approach games.")));
};
exports.About = About;
